<template>
  <div class="horizon-container">
    <div class="flex-1 w-0 h-100 flex-column ptb-10 plr-20">
      <div class="flex content-top">
        <div class="flex-1 bg-ff h-100 flex align-center pl-10 mr-10">
          <div class="flex align-center mr-20 cursor">
            <div class="mr-5 decoration-line" ></div>
            <div class="font-bold font-16-f5971d" >待记账工程款</div>
          </div>
        </div>
      </div>
      <div class="mt-10 mb-5 flex flex-wrap">
        <div class="flex align-center mr-5 mb-5 btn-24-bg-ff" @click="toAccount">
          <img src="/static/images/shangmenyubao.png" class="icon-14 mr-5" alt="">
          <div>记账</div>
        </div>
      </div>
      <div class="flex-1 h-0 flex-column">
        <div class="flex-1 h-0">
          <erp-table ref="erpTable" @change-current-row="changeCurrentRow" :table-data="tableData" :loading="loading" :column-data="columnData" :table-footer="tableFooter"></erp-table>
        </div>
        <pagination :page-size="pages" :page-no="page" v-model="page" :page-total="pageTotal" :total="total" @on-jump="jump"></pagination>
      </div>
      <move-vertical :max="560" :min="220" class="mtb-5" moveDom="bottom"></move-vertical>
      <div id="moveTop" class="flex-column" style="height: 260px">
        <div class="flex align-center">
          <div class="flex align-center mr-20 cursor pb-5 relative tabActive">
            <div class="mr-5 decoration-line"></div>
            <div class="font-bold font-16-f5971d">收款记录历史</div>
          </div>
          <div class="flex font-12-ff5555">{{currentRow.customerName || ''}} / {{currentRow.customerAddress || ''}}</div>
        </div>
        <div class="hr"></div>
        <div class="thColor mt-10 flex-1" style="min-height: 200px">
          <erp-table ref="erpTable1" :table-data="tableData2" :loading="loading2" :column-data="columnData1" :table-footer="tableFooter1"></erp-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Pagination from '../../components/Pagination'
import MoveHorizon from '../../components/MoveHorizon'
import MoveVertical from '../../components/MoveVertical'
import ErpTable from '../../components/ErpTable'
export default {
  name: 'recordedProjectFund',
  components: {Pagination, MoveHorizon, MoveVertical, ErpTable},
  data () {
    return {
      keywords: '',
      page: 1,
      limit: 20,
      pages: 0,
      total: 0,
      pageTotal: 0,
      classifyList: [],
      tableFooter: [{
        columns: ['money'],
        type: 'sum',
        name: '合计'
      }],
      tableFooter1: [{
        columns: ['money'],
        type: 'sum',
        name: '合计'
      }],
      columnData: [
        {
          type: 'selection',
          width: '50',
          fixed: 'left'
        }, {
          field: 'account',
          title: '收款账户',
          width: '100'
        }, {
          field: 'itemName',
          title: '款项内容',
          width: '150'
        }, {
          field: 'money',
          title: '金额',
          width: '80'
        }, {
          field: 'customerAddress',
          title: '客户/装修地址',
          minWidth: '150'
        }, {
          field: 'number',
          title: '单据编号',
          minWidth: '120'
        }, {
          field: 'writingNumber',
          title: '纸质单号',
          width: '100'
        }, {
          field: 'createTime',
          title: '收款日期',
          width: '100',
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'operatorName',
          title: '收款人',
          width: '100'
        }
      ],
      columnData1: [
        {
          field: 'accountTime',
          title: '记账日期',
          width: '100',
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'number',
          title: '单据号',
          minWidth: '120'
        }, {
          field: 'itemName',
          title: '款项内容',
          width: '200'
        }, {
          field: 'money',
          title: '金额',
          width: '100'
        }, {
          field: 'account',
          title: '收款账户',
          width: '120'
        }, {
          field: 'operatorName',
          title: '收款人',
          width: '80'
        }, {
          field: 'accounterName',
          title: '记账人',
          width: '80'
        }, {
          field: 'writingNumber',
          title: '纸质单号',
          minWidth: '120'
        }
      ],
      chooseMenuId: 0,
      currentClassify: {},
      loading: false,
      loading2: false,
      tableData: [],
      srcList: [],
      smallTab: ['材料信息', '材料说明', '材料图片', '二维码'],
      smallTabIndex: 0,
      isErcodeShow: false,
      currentRow: {},
      tableData2: []
    }
  },
  created () {},
  mounted () {
    this.getData()
  },
  methods: {
    toAccount () {
      let dataArr = this.$refs.erpTable.getSelectEvent()
      if (dataArr.length === 0) {
        this.$message.warning('请选择要记账的数据')
      } else {
        let idArr = []
        let that = this
        for (let i = 0; i < dataArr.length; i++) {
          idArr.push(dataArr[i].id)
        }
        this.$confirm(`是否为选中数据进行几张？`, '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.axios.post('financeBill/accounting', {ids: idArr.join(',')}).then(res => {
            if (res.data.success) {
              that.getData()
              that.tableData2 = []
              that.currentRow = {}
              that.$message.success('记账成功')
            } else {
              that.$message({
                message: res.data.msg,
                type: 'error',
                offset: 400
              })
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
      }
    },
    getDetail () {
      this.loading2 = true
      let params = {
        customerId: this.currentRow.customerId,
        status: 2
      }
      this.axios.post('financeBill/list', params).then(res => {
        this.loading2 = false
        if (res.data.success) {
          this.tableData2 = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    changeCurrentRow (row) {
      this.currentRow = row
      this.getDetail()
    },
    getData () {
      this.loading = true
      let params = {
        page: this.page,
        limit: this.limit,
        companyId: this.$store.state.companyId,
        status: 1
      }
      this.axios.post('financeBill/queryForPage', params).then(res => {
        this.loading = false
        if (res.data.success) {
          this.tableData = res.data.data.list
          this.pages = res.data.data.pages
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    jump (page) {
      this.page = page
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      line-height: 30px;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #f5971d;
      }
    }
  }
  .el-icon-zoom-in {
    position: absolute;
    bottom: 10px;
    right: 10px;
    font-size: 14px;
    color: #30313a;
  }
  .font-13-f5971d {
    font-size: 13px;
    color: #f5971d;
  }
  .el-card {
    height: 90px;
    border: 1px solid #e2e2e2;
    cursor: pointer;
  }
  .info-item {
    width: 198px;
    border-bottom: 1px solid #e2e2e2;
    display: flex;
    align-items: center;
    margin-top: 10px;
    font-size: 12px;
    color: #30313a;
    margin-right: 30px;
    line-height: 20px;
    height: 20px;
  }
  .thColor /deep/ .vxe-header--column {
    border: 2px #e2e2e2 !important;
    border-right: dashed 1px #e2e2e2 !important;
    background-color: #f3f4f7 !important;
  }
  .thColor /deep/.vxe-table.t--border .vxe-header--column .vxe-cell {
    color: #30313a !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/financeManage/recordedProjectFund.vue